import { render, staticRenderFns } from "./TableEx.vue?vue&type=template&id=1579ab32&scoped=true&"
import script from "./TableEx.vue?vue&type=script&lang=js&"
export * from "./TableEx.vue?vue&type=script&lang=js&"
import style0 from "./TableEx.vue?vue&type=style&index=0&id=1579ab32&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1579ab32",
  null
  
)

export default component.exports